var map = {
	"./academy/ai_money.png": 92186,
	"./academy/basicos_binarias.jpg": 39695,
	"./academy/binarias.jpeg": 86293,
	"./academy/cryptospace.jpeg": 79561,
	"./academy/deportes.jpeg": 27625,
	"./academy/english_advanced.png": 76422,
	"./academy/english_basic.png": 46322,
	"./academy/english_interm.png": 93121,
	"./academy/forex.jpeg": 23476,
	"./academy/marketking.jpeg": 11162,
	"./academy/mk_workshop.jpeg": 37634,
	"./default-card.png": 76575,
	"./liderazgo/clase_gratis.png": 97803,
	"./liderazgo/clase_gratis_lap.png": 92291,
	"./liderazgo/fhh.png": 29566,
	"./liderazgo/gtr_woman.png": 73527,
	"./liderazgo/influencers.png": 33001,
	"./liderazgo/inicio_rapido.png": 68930,
	"./liderazgo/mentoria.png": 79137,
	"./liderazgo/mindsetcall.png": 11178,
	"./liderazgo/plan_de_negocios.png": 45724,
	"./liderazgo/testimonios.png": 34870,
	"./liderazgo/wakeup_call.png": 16219,
	"./past/600_y_sup.png": 55545,
	"./past/binarias.png": 39335,
	"./past/binary-options.jpg": 91490,
	"./past/clase_gratis_lap.png": 26921,
	"./past/clase_gratis_libreta.png": 23156,
	"./past/cryptospace.png": 5924,
	"./past/default-card.jpg": 23494,
	"./past/deportes.png": 28115,
	"./past/forex.png": 59263,
	"./past/gtr metal.png": 5634,
	"./past/inicio_rapido.png": 5040,
	"./past/kinder-forex.jpg": 18413,
	"./past/market-analysis.jpg": 39352,
	"./past/marketking.png": 71351,
	"./past/mentoria.png": 73035,
	"./past/mentoria2.png": 6758,
	"./past/mindsetcall.png": 61578,
	"./past/plan_de_negocios.png": 85012,
	"./past/testimonios.png": 88563,
	"./past/trading-deportivo.jpg": 30313,
	"./past/wakeup_call.png": 746
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7638;